import { Box } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./LinkTranslated.styles";

/**
 * * this component is used to translate the link component because
 * * i18n does not support a/Link components directly inside the Trans component
 * @interface ILinkTranslatedProps
 * @param {string} moveTo - path to move to
 * @param {React.ReactNode} children - children to render
 * @returns {JSX.Element}
 */
const LinkTranslated: React.FC<ILinkTranslatedProps> = ({ moveTo, newTab, children, insideTransComponent }) => {
    const { t } = useTranslation();

    const handleClick = () => window.open(moveTo);

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleClick();
        }
    };

    if (newTab)
        return (
            <Box
                role="link"
                component="span"
                tabIndex={0}
                style={{ ...styles.LinkContainer, margin: `0px ${insideTransComponent ? "4px" : "0px"}` }}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                aria-label={`${t("certificate_validator.accessibility.opens_in_new_tab")}: ${children}`}
            >
                {children}
            </Box>
        );
    return (
        <a href={moveTo} style={styles.LinkContainer}>
            {children}
        </a>
    );
};

export default LinkTranslated;
